/**
 * HTML エスケープユーティリティ
 */

/** テキストを HTML エスケープする */
export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
